import { ReactElement } from "react";

interface NotificationCardProps {
  spaName: string;
  timeAgo: string;
  avatar?: string | ReactElement;
  title: string;
  message: string;
  className?: string;
  onClick?: () => void;
}

export const NotificationCard = ({
  spaName,
  timeAgo,
  avatar,
  title,
  message,
  className = "",
  onClick,
}: NotificationCardProps) => {
  return (
    <div
      className={`relative flex w-full flex-col gap-[3px] rounded-[16px] px-[18px] py-4 ${className}`}
      onClick={onClick}
    >
      {/* Header with spa name, time, and avatar */}
      <div className="relative mb-2 flex items-center">
        {avatar && (
          <div className="relative ml-0 mt-0 max-h-6 max-w-6 flex-shrink-0 overflow-hidden">
            {typeof avatar === "string" ? (
              <img
                src={avatar}
                alt={spaName}
                className="pointer-events-none size-full max-h-6 max-w-6 object-cover object-[50%_50%]"
              />
            ) : (
              avatar
            )}
          </div>
        )}
        <p
          className="relative ml-2 mt-0 font-sans text-[12px] font-normal text-black"
          style={{ fontVariationSettings: "'opsz' 14" }}
        >
          {spaName}
        </p>
        <p
          className="relative ml-auto mt-0 shrink-0 text-right font-sans text-[12px] font-normal text-black"
          style={{ fontVariationSettings: "'opsz' 14" }}
        >
          {timeAgo}
        </p>
      </div>

      {/* Title */}
      <div className="relative w-[139px] shrink-0">
        <p
          className="font-sans text-[12px] font-normal text-black"
          style={{ fontVariationSettings: "'opsz' 14" }}
        >
          <span className="font-bold" style={{ fontVariationSettings: "'opsz' 14" }}>
            {title}
          </span>
        </p>
      </div>

      {/* Message */}
      <p
        className="relative h-[47px] w-[276px] shrink-0 font-sans text-[12px] font-normal text-black"
        style={{ fontVariationSettings: "'opsz' 14" }}
      >
        {message}
      </p>
    </div>
  );
};
